<!-- Button -->
<ac-button type="icon" [matTooltip]="'Contact us' | transloco" (click)="openContactUs()">
    <ng-container [ngTemplateOutlet]="defaultIconTpl"></ng-container>
    <ng-template #defaultIconTpl>
        <mat-icon>report</mat-icon>
    </ng-template>
</ac-button>

<!-- <button mat-icon-button [matTooltip]="'Contact us'" (click)="openContactUs()">
    <ng-container [ngTemplateOutlet]="defaultIconTpl"></ng-container>
    <ng-template #defaultIconTpl>
        <mat-icon>report</mat-icon>
    </ng-template>
</button> -->